import { Platform } from '@angular/cdk/platform'
import { AfterViewInit, Component, ErrorHandler, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ChangeDetectionStrategy, Injector, inject, signal } from '@angular/core'
import { form, required } from '@angular/forms/signals'
import { DateAdapter } from '@angular/material/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, Router } from '@angular/router'

// import { LaskuKatseleComponentExistingData } from '../_angular/_resolvers/lasku.resolve'

import { LemonDateAdapter } from '../_jaettu-angular/_material/LemonDateAdapter'
import { LemonTranslationService } from '../_jaettu-angular/service/lemon-translation.service'

import { DateService } from '@lemon/core/service/date.service'
// import { LaskunAsiakas, LaskunListaustietorivi, Lasku } from '@lemon/core-firebase/model/lasku'

// import { LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenDialog, LaskuHaluatkoVarmastiPeruaMaksetuksiMerkitsemisenDialogData } from './dialogit/lasku.haluatko-varmasti-perua-maksetuksi-merkitsemisen.dialog'

import { BehaviorSubject, Observable, ReplaySubject, Subject, Subscription, combineLatest, debounceTime, filter, map, of as observableOf, of, switchMap, takeUntil, takeWhile } from 'rxjs'

import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox'
import { MatPaginator } from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'
import { ApixReceivedInvoiceConfig } from '@lemon/core-firebase/model/apix'
import { LemonaidPaymentConfig } from '@lemon/core-firebase/model/kayttaja'
import { LaskuToimittaja, TypeaheadToimittaja, TypeaheadToimittajaDokumentti } from '@lemon/core-firebase/model/lasku'
import { LatestBankBalance } from '@lemon/core-firebase/model/tiliote'
import { FirestoreTosite, PaymentStatus } from '@lemon/core-firebase/model/tosite'
import { AsiakasJaettuLemonaidService } from '@lemon/core-firebase/service/asiakas-jaettu-lemonaid.service'
import { BankBalancePublicUriService } from '@lemon/core-firebase/service/bank-balance-public-uri.service'
import { FirestoreIndeksoija } from '@lemon/core-firebase/service/firestore.indeksoija'
import { LaskuUriService } from '@lemon/core-firebase/service/lasku/lasku-uri.service'
import { MaksutService } from '@lemon/core-firebase/service/maksut.service'
import { ToimittajaTunnisteService } from '@lemon/core-firebase/service/lasku/toimittaja-tunniste.service'
import { TositeKopioija } from '@lemon/core-firebase/service/tosite/tosite.kopioija'
import { PaymentRejectionReason } from '@lemon/core/model/payment'
import { BicService } from '@lemon/core/service/bic.service'
import { CurrencyService } from '@lemon/core/service/currency.service'
import { IbanService } from '@lemon/core/service/iban.service'
import { StringService } from '@lemon/core/service/string.service'
import { MaksuKatseleComponentDataResolve, MaksuKatseleComponentExistingData, MaksuLuoUusiComponentData, MaksuLuoUusiComponentDataResolve } from 'app/_angular/_resolvers/maksu.resolve'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { TositeHakuStateService } from 'app/_angular/service/tosite-haku-state.service'
import { VersionTarkistusPalvelu } from 'app/_angular/service/version-tarkistus.palvelu'
import { LoadingConfig } from 'app/_jaettu-angular/_components/loading.component'
import { lemonShare } from 'app/_jaettu-angular/_rxjs/lemon-share.operator'
import { arvonMuutokset, asetaArvo } from 'app/_jaettu-angular/_lomakkeet/arvon-muutokset'
import { FormValidationService } from 'app/_jaettu-angular/service/form-validation.service'
import { LaskunToimittajaTypeaheadBase } from 'app/_jaettu-angular/service/lasku/typeahead.service'
import { TiedostojenLataamisService } from 'app/_jaettu-angular/service/tiedostojen-lataamis.service'
import { TimestampService } from 'app/_jaettu-angular/service/timestamp-service'
import { MaksutVahvistusData } from 'app/tunnistautuminen/nets/maksujen-vahvistus-pankit.component'
import { FileSystemFileEntry } from '../_jaettu-angular/file-drop/file-drop-dom.types'
import { FileDropEntry } from '../_jaettu-angular/file-drop/file-drop-entry'
import { MaksutSharedStateService } from './maksut-shared-state.service'
import { MaksunLokalisoituTila, MaksutFirestoreDataSource, OstolaskuSort } from './maksut.firestore.datasource'

// import { LaskuTaydennaAsetuksetDialog } from './dialogit/lasku-taydenna-asetukset.dialog'
// import { LaskuKommenttiDialog, LaskuKommenttiDialogData } from './dialogit/lasku-kommentti.dialog'

// export type TuoteProperties = 'nro' | 'asiakas' | 'pvm' | 'erapvm' | 'summa' | 'avoinna' | 'tila' | 'merkitse' | undefined

type ViewType = 'vastaanotto' | 'hyvaksynta' | 'maksaminen'
type ViewTab = 'avoimet' | 'kaikki'

export enum KaikkiHakuFormPvmTyyppi {
  LASKU = 'lasku',
  MAKSU = 'maksu',
}

interface MaksutiliLomake {
  config: NaytettavaConfig | null
}

interface KaikkiHakuLomake {
  tila: MaksunLokalisoituTila['tunnus'] | null
  toimittaja: LaskuToimittaja | string | null
  pvmTyyppi: KaikkiHakuFormPvmTyyppi | null
  alku: Date | null
  loppu: Date | null
}

interface YhteensaRivi {
  valuutta: string
  yhteensa: number
}

interface NaytettavaConfig extends Pick<LemonaidPaymentConfig, 'avain' | 'iban' | 'debtorIdentifier'> {
  pankki: string
}

interface NakymanAsetukset {
  naytaListaus: boolean
  naytaLaskujenVastaanottoEiPaallaTeksti: boolean
  vaatiiHyvaksynnan: boolean
  valittuTab: ViewTab
  viewType: ViewType
  naytaLisaaButton: boolean
}

interface MaksutTosite extends FirestoreTosite {
  maksuHyvaksytty: boolean
  virhe: boolean
  virheviesti: string
  summaChanged: boolean
  erapaivaChanged: boolean
  maksunsaajaChanged: boolean
  voidaanValita: boolean
  naytaValinta: boolean
  valittu: boolean
  valintaOhjeistus: string
  toimittaja: TypeaheadToimittaja
}

interface LatestBankBalanceInfo extends LatestBankBalance {
  iban: string
}

@Component({
  templateUrl: './maksut.component.html',
  styleUrls: ['./maksut.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    { provide: DateAdapter, useClass: LemonDateAdapter, deps: [ErrorHandler, DateService, Platform, LemonTranslationService] },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MaksutComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('fileInput', { static: true }) fileInput
  @ViewChild('selectAllCheckbox', { static: false, read: MatCheckbox }) selectAllCheckbox: MatCheckbox

  // @ViewChild('laskutaulu', { static: true }) laskutaulu: ElementRef
  @ViewChild('paginator', { static: false, read: MatPaginator })
  set paginator(p: MatPaginator) {
    this.pageSubscription?.unsubscribe()

    if (p) {
      if (this.dataSource?.page) {
        p.pageIndex = this.dataSource.page.pageIndex
        p.pageSize = this.dataSource.page.pageSize
      }

      this.pageSubscription = p.page.pipe(takeUntil(this._ngUnsubscribe)).subscribe(page => {
        this.dataSource.page = page
      })
    }
  }
  @ViewChildren(MatSort) sortQl: QueryList<MatSort>

  pageSubscription: Subscription

  private _ngUnsubscribe = new Subject<void>()
  private readonly _injector = inject(Injector)
  // private _taydennaAsetuksetDialogi: MatDialogRef<LaskuTaydennaAsetuksetDialog> = null
  // private _kommenttiDialogi: MatDialogRef<LaskuKommenttiDialog> = null

  maksutiliLomake = form(signal<MaksutiliLomake>({ config: null }), polku => {
    required(polku.config)
  })

  hakuAvoinna = false

  kaikkiHakuLomake = form(signal<KaikkiHakuLomake>({ tila: 'k', toimittaja: null, pvmTyyppi: null, alku: null, loppu: null }), polku => {
    required(polku.tila)
    required(polku.pvmTyyppi)
  })
  suodatetutToimittajat: ReplaySubject<TypeaheadToimittaja[]> = new ReplaySubject<TypeaheadToimittaja[]>(1)
  toimittajatMapObservable: Observable<Map<TypeaheadToimittaja['avain'], TypeaheadToimittaja>>

  // propertiesToDisplay: TuoteProperties[] = []
  maksunTilatObservable: Observable<MaksunLokalisoituTila[]>
  // tableViewOptionsObservable: Observable<{ showAddButton: boolean, showCommentsColumn: boolean }>

  nakyvatRivitObservable: Observable<MaksutTosite[]>
  yhteensaRivitObservable: Observable<YhteensaRivi[]>
  kokonaismaaraObservable: Observable<{ maara: number }>
  nakymanAsetuksetObservable: Observable<NakymanAsetukset>

  private _selectedTabSubject: BehaviorSubject<ViewTab> = new BehaviorSubject('avoimet')
  private _valitutTositteetSubject: BehaviorSubject<FirestoreTosite[]> = new BehaviorSubject([])
  private _valitutTositteetObservable: Observable<FirestoreTosite[]> = this._valitutTositteetSubject.asObservable()
  private _valittuNaytettavaConfigSubject: BehaviorSubject<NaytettavaConfig> = new BehaviorSubject(null)
  valittujenTositteidenSummaObservable: Observable<number> = this._valitutTositteetObservable.pipe(
    map(
      tositteet =>
        tositteet
          ?.map(tosite => {
            // Maksutiedot sisältää varsinaisen maksettavan summan (esim. jos ostolaskun maksutietoja on muokattu)
            const maksutiedot = this._tositeKopioija.annaMaksutiedot(tosite)
            return maksutiedot.amount
          })
          .reduce((partialSum, a) => partialSum + a, 0) || 0,
    ),
  )
  valittujenTositteidenMaaraObservable: Observable<number> = this._valitutTositteetObservable.pipe(map(tositteet => tositteet?.length || 0))
  latestBankBalanceObservable: Observable<LatestBankBalanceInfo>

  naytaEiYhtaanObservable: Observable<boolean>
  lataaObservable: Observable<boolean>
  paymentConfigsObservable: Observable<NaytettavaConfig[]>
  naytaLisaaButtonObservable: Observable<boolean>
  name = 'asdasdfaaf' + Math.random()

  countToAvoinna: number = 0
  countToTilinSaldo: number = 0
  countToEraantynyt: number = 0
  readonly avoinnaTo = signal(0)
  avoinnaFrom: number = 0
  readonly eraantynytTo = signal(0)
  eraantynytFrom: number = 0
  tilinSaldoFrom: number = 0
  valuutta: string = 'EUR'
  readonly selectedTabIndex = signal(0)

  // private _alustaSummat = true
  // private _pauser = new Subject<boolean>()

  loadingSettings: LoadingConfig = {
    fullScreenBackdrop: false,
    backdropBackgroundColour: 'rgba(0,0,0,0.15)',
    backdropBorderRadius: '4px',
    primaryColour: 'rgba(255, 255, 255, 1)',
    secondaryColour: 'rgba(255, 255, 255, 1)', // rgba(252, 238, 32, .15)
    tertiaryColour: 'rgba(255, 255, 255, 1)',
  }

  private _selectedMaksut: Map<string, FirestoreTosite> = new Map()
  private _dataSource: MaksutFirestoreDataSource
  private _viewTypeObservable: Observable<ViewType>

  readonly PaymentStatus = PaymentStatus
  readonly KaikkiHakuFormPvmTyyppi = KaikkiHakuFormPvmTyyppi

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _errorHandler: ErrorHandler,
    private _dialog: MatDialog,
    // private _laskuSummatService: LaskuSummatService,
    // private _windowSizeService: WindowSizeService,
    // private _dateAdapter: DateAdapter<Date>,
    private _versionTarkistaja: VersionTarkistusPalvelu,
    private _tiedostojenLataamisService: TiedostojenLataamisService,
    private _kayttajaService: KayttajaService,
    private _lemonTranslationService: LemonTranslationService,
    private _currencyService: CurrencyService,
    private _dateService: DateService,
    private _firestoreIndeksoija: FirestoreIndeksoija,
    private _firebaseLemonaid: FirebaseLemonaid,
    private _luoComponentDataResolve: MaksuLuoUusiComponentDataResolve,
    private _katseleComponentDataResolve: MaksuKatseleComponentDataResolve,
    private _bankBalancePublicUriService: BankBalancePublicUriService,
    private _bicService: BicService,
    private _ibanService: IbanService,
    private _maksutSharedStateService: MaksutSharedStateService,
    private _asiakasJaettuLemonaidService: AsiakasJaettuLemonaidService,
    private _maksutService: MaksutService,
    private _tositeKopioija: TositeKopioija,
    private _timestampService: TimestampService,
    private _stringService: StringService,
    private _formValidationService: FormValidationService,
    private _laskuUriService: LaskuUriService,
    private _toimittajaTypeahead: LaskunToimittajaTypeaheadBase,
    private _hakuStateService: TositeHakuStateService,
    private _toimittajaTunnisteService: ToimittajaTunnisteService,
  ) {
    this._dataSource = this._maksutSharedStateService.getDataSource()
    this._dataSource.searchParameters = {} // Resetoidaan hakuparameterit
    this._dataSource.lajittelutiedot = null // Resetoidaan lajittelutiedot
    this._dataSource.unLockResultSet()
    this._dataSource.markAsInitialized()
    this._dataSource.tilat = this._annaAvoimetTilat()
    this.kokonaismaaraObservable = this._dataSource.rivienKokonaismaaraObservable.pipe(
      map(m => {
        return { maara: m }
      }),
    )
    this.lataaObservable = this._dataSource.lataaObservable
    this.naytaEiYhtaanObservable = combineLatest([this._dataSource.rivienKokonaismaaraObservable, this._dataSource.lataaObservable]).pipe(
      debounceTime(2000),
      map(([rivienMaara, lataa]) => {
        if (lataa) {
          return false
        }
        return rivienMaara < 1
      }),
    )

    this._selectedTabSubject.pipe(takeUntil(this._ngUnsubscribe)).subscribe(() => {
      this._selectedMaksut.clear()
      this._valitutTositteetSubject.next([])
    })
  }

  private _annaAvoimetTilat(): PaymentStatus[] {
    return [PaymentStatus.AVOIN, PaymentStatus.ERAANTYNYT, PaymentStatus.MAKSUSSA, PaymentStatus.PANKKI_HYLKASI]
  }

  tabChanged(idx: number) {
    this._maksutSharedStateService.tallennaValittuTab(idx)
    if (idx === 0) {
      this.vaihdaValilehtiAvoimiin()
    } else if (idx === 1) {
      this.vaihdaValilehtiKaikkiin()
    }
  }

  asetaKaikkiHakuParametrit() {
    const kaikkiHakuArvot = this.kaikkiHakuLomake().value()
    this.dataSource.searchParameters = {
      ...kaikkiHakuArvot,
      toimittaja: this._stringService.isString(kaikkiHakuArvot.toimittaja) ? null : kaikkiHakuArvot.toimittaja,
    }
  }

  vaihdaValilehtiAvoimiin() {
    if (this._selectedTabSubject.value !== 'avoimet') {
      this._selectedTabSubject.next('avoimet')
      this.dataSource.searchParameters = {} // Resetoidaan hakuparameterit
      this.dataSource.lajittelutiedot = null // Resetoidaan lajittelutiedot
      this.dataSource.tilat = this._annaAvoimetTilat()

      this._router.navigate([], {
        relativeTo: this._route,
        queryParams: { tab: null },
        queryParamsHandling: 'merge',
        replaceUrl: true,
      })
    }
  }

  vaihdaValilehtiKaikkiin() {
    if (this._selectedTabSubject.value !== 'kaikki') {
      this._selectedTabSubject.next('kaikki')
      this.asetaKaikkiHakuParametrit() // Asetetaan olemassaolevat hakuparametrit käyttöön
      this.dataSource.lajittelutiedot = {
        // Resetoidaan lajittelutiedot
        active: null,
        direction: 'asc',
      }
      if (!this.kaikkiHakuLomake.pvmTyyppi().value()) {
        asetaArvo(this.kaikkiHakuLomake.pvmTyyppi, KaikkiHakuFormPvmTyyppi.LASKU)
      }
    }
  }

  ngOnInit() {
    if (this._hakuStateService.onkoTallennettuHaku(this._router.url)) {
      this.hakuAvoinna = true
    }

    this._route.queryParams.pipe(takeUntil(this._ngUnsubscribe)).subscribe(params => {
      if (params && params['tab'] === 'kaikki') {
        this.selectedTabIndex.set(1)
        this.vaihdaValilehtiKaikkiin()
      }
    })

    const apixConfigObservable = this._kayttajaService.kayttajaObservable.pipe(
      switchMap(kayttaja => {
        if (!kayttaja) {
          return observableOf<ApixReceivedInvoiceConfig>(null)
        }
        return this._firebaseLemonaid.firestoreDoc<ApixReceivedInvoiceConfig>('customers/' + kayttaja.asiakasAvain + '/apix-received-invoice-config/' + kayttaja.asiakasAvain).listen()
      }),
    )

    this.paymentConfigsObservable = this._kayttajaService.nykyinenAsiakasObservable.pipe(
      map(asiakas => {
        if (asiakas?.paymentConfigs) {
          return asiakas.paymentConfigs
            .filter(paymentConfig => this._maksutService.onkoMaksutiliVoimassa(paymentConfig))
            .map(paymentConfig => {
              const naytettava: NaytettavaConfig = {
                avain: paymentConfig.avain,
                iban: this._ibanService.formatoiIban(paymentConfig.iban),
                pankki: this._bicService.annaPankinNimi(paymentConfig.iban),
                debtorIdentifier: paymentConfig.debtorIdentifier,
              }
              return naytettava
            })
        }
        return []
      }),
    )

    this._viewTypeObservable = combineLatest([this._kayttajaService.nykyinenAsiakasObservable, this._kayttajaService.kayttajaObservable, apixConfigObservable, this.paymentConfigsObservable]).pipe(
      map(([asiakas, kayttaja, apixConfig, paymentConfigs]) => {
        if (!asiakas || !kayttaja?.roolit || !apixConfig) {
          return 'vastaanotto'
        }

        if (apixConfig.paymentIsActive) {
          if (asiakas.paymentsNeedsApproval && kayttaja.roolit.MAKSUT_HYVAKSYJA && !kayttaja.roolit.MAKSUT_MAKSAJA) {
            return 'hyvaksynta'
          }
          if (kayttaja.roolit.MAKSUT_MAKSAJA && paymentConfigs.length) {
            return 'maksaminen'
          }
        }

        return 'vastaanotto'
      }),
    )

    this.naytaLisaaButtonObservable = this._selectedTabSubject.pipe(
      map(selectedTab => {
        return selectedTab === 'avoimet'
      }),
    )

    this.nakymanAsetuksetObservable = combineLatest([apixConfigObservable, this._kayttajaService.nykyinenAsiakasObservable, this._selectedTabSubject, this._viewTypeObservable]).pipe(
      map(([config, asiakas, selectedTab, viewType]) => {
        const val: NakymanAsetukset = {
          naytaListaus: config && (!!config.paymentReceiveIsActive || !!config.paymentIsActive),
          naytaLaskujenVastaanottoEiPaallaTeksti: config && config.paymentIsActive && !config.paymentReceiveIsActive,
          vaatiiHyvaksynnan: !!asiakas?.paymentsNeedsApproval,
          valittuTab: selectedTab,
          viewType: viewType,
          naytaLisaaButton: selectedTab === 'avoimet',
        }
        return val
      }),
    )

    this._versionTarkistaja.sovelluksenVersioObservable.pipe(takeUntil(this._ngUnsubscribe)).subscribe(versiotiedot => {
      this._versionTarkistaja.tarkistaVersio(versiotiedot)
    })

    this.latestBankBalanceObservable = combineLatest([this._kayttajaService.nykyinenAsiakasObservable, this._valittuNaytettavaConfigSubject, this._viewTypeObservable]).pipe(
      switchMap(([asiakas, naytettavaConfig, viewType]) => {
        if (
          !asiakas?.asiakasAvain ||
          !naytettavaConfig?.iban ||
          viewType !== 'maksaminen' // Näytetään vain maksajille
        ) {
          return observableOf<LatestBankBalanceInfo>(null)
        }
        const uri = this._bankBalancePublicUriService.getLatestBankBalanceUri(asiakas.asiakasAvain, this._stringService.removeAllWhiteSpaces(naytettavaConfig.iban))
        return this._firebaseLemonaid
          .firestoreDoc<LatestBankBalance>(uri)
          .listen()
          .pipe(
            map(latestBankBalance => {
              return latestBankBalance ? { ...latestBankBalance, iban: naytettavaConfig.iban } : null
            }),
          )
      }),
    )

    // this.asetaListauksenKolumnit()

    // this.translationService.currentLanguageObservable.pipe(
    //   takeUntil(this._ngUnsubscribe)
    // ).subscribe(kieli => {
    //   this.dateAdapter.setLocale(kieli)
    // })

    // this.laskuService.asetuksetObservable.pipe(
    //   takeUntil(this.ngUnsubscribe)
    // ).subscribe(asetukset => {
    //   if (asetukset && !asetukset.summahuomautusPiilotettu) {
    //     this.naytaHuomautus = true
    //   } else {
    //     this.naytaHuomautus = false
    //   }
    // }, error => {
    //   this.errorHandler.handleError(error)
    // })

    // this._pauser.pipe(
    //   switchMap(aktiivinen => {
    //     return iif(() => aktiivinen, this.laskuSummatService.summatObservable, EMPTY)
    //   }),
    //   throttleTime(1100, undefined, { leading: true, trailing: true }),
    //   takeUntil(this._ngUnsubscribe)
    // ).subscribe(summat => {
    //   // console.log('summat', JSON.stringify(summat))
    //   if (summat) {

    //     // Mikä valuutta
    //     this.valuutta = summat.valuutta

    //     // Mistä rullataan
    //     this.avoinnaFrom = summat.avoinnaAlkuperainen
    //     this.eraantynytFrom = summat.eraantynytAlkuperainen

    //     // Mihin rullataan
    //     if (this._alustaSummat) {
    //       this._alustaSummat = false
    //       setTimeout(() => {
    //         this.avoinnaTo = summat.avoinna
    //         this.eraantynytTo = summat.eraantynyt
    //       }, 150)
    //     } else {
    //       this.avoinnaTo = summat.avoinna
    //       this.eraantynytTo = summat.eraantynyt
    //     }

    //   }
    // }, error => {
    //   this.errorHandler.handleError(error)
    // })
    // this._pauser.next(true)

    this.maksunTilatObservable = this.dataSource.maksunTilatObservable
    // this.tableViewOptionsObservable = this.kayttajaService.kayttajanTiedotObservable.pipe(
    //   map(kayttaja => {
    //     return { showAddButton: kayttaja?.asiakasId !== '9', showCommentsColumn: kayttaja?.asiakasId === '9' }
    //   }),
    //   startWith({ showAddButton: true, showCommentsColumn: false })
    // )

    // Must be done before the next step is done to correctly record the default set.
    arvonMuutokset(this.maksutiliLomake.config, { injector: this._injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe(naytettavaConfig => {
        this._valittuNaytettavaConfigSubject.next(naytettavaConfig)
      })

    this.paymentConfigsObservable.pipe(takeWhile(config => !config, true)).subscribe(configs => {
      if (!this.maksutiliLomake.config().value() && configs?.length > 0) {
        asetaArvo(this.maksutiliLomake.config, configs[0])
      }
    })

    // this.route.data.pipe(
    //   takeUntil(this._ngUnsubscribe)
    // ).subscribe((data: { data: LaskutComponentData }) => {
    //   if (data && data.data && data.data.nollaaHakuasetukset) {
    //     this.dataSource.resetSearchToDefaults()
    //   }
    // }, error => {
    //   this.errorHandler.handleError(error)
    // })

    this.toimittajatMapObservable = this._kayttajaService.kayttajanTiedotObservable.pipe(
      filter(kayttajanTiedot => !!kayttajanTiedot),
      switchMap(kayttajanTiedot => {
        return this._firebaseLemonaid
          .firestoreDoc<TypeaheadToimittajaDokumentti>(this._laskuUriService.getTypeaheadToimittajaDokumentinUriNew(kayttajanTiedot.asiakasAvain))
          .listen()
          .pipe(
            map(dokumentti => {
              const toimittajatMap = new Map<string, TypeaheadToimittaja>()
              if (dokumentti) {
                for (const [key, value] of Object.entries(dokumentti)) {
                  toimittajatMap.set(key, { avain: key, ...value })
                }
              }
              return toimittajatMap
            }),
          )
      }),
      lemonShare(),
    )

    this.nakyvatRivitObservable = combineLatest([this.dataSource.connect(), this._kayttajaService.nykyinenAsiakasObservable, this.toimittajatMapObservable]).pipe(
      map(([tositteet, asiakas, toimittajatMap]) => {
        const paymentEnabledStatuses = [PaymentStatus.AVOIN, PaymentStatus.ERAANTYNYT, PaymentStatus.PANKKI_HYLKASI]
        return tositteet.map((tosite: MaksutTosite) => {
          this._timestampService.fixTimestamps(tosite)
          tosite.maksuHyvaksytty = this._maksutService.onkoMaksuHyvaksytty(tosite, asiakas)
          tosite.virhe = tosite.paymentStatus === PaymentStatus.PANKKI_HYLKASI
          tosite.summaChanged = tosite.maksutiedot && tosite.maksutiedot.amount !== tosite.sum
          tosite.erapaivaChanged = tosite.maksutiedot && tosite.maksutiedot.dueDate !== tosite.dueDate
          tosite.maksunsaajaChanged = tosite.maksutiedot && tosite.maksutiedot.maksunSaajanNimi !== tosite.seller

          if (tosite.virhe) {
            const start = this._lemonTranslationService.lokalisoi('maksut.maksu-hylkaamisen-syy')
            const error = this._lemonTranslationService.lokalisoi('maksut.maksu-epaonnistui-' + (tosite.paymentRejection?.reason ?? '1'))
            const detailErrMsg = tosite.paymentRejection?.reason === PaymentRejectionReason.UNKNOWN ? ' (' + tosite.paymentRejection?.rawText + ')' : ''
            tosite.virheviesti = `${start}: ${error}${detailErrMsg}`
          }

          const maksutiedot = this._tositeKopioija.annaMaksutiedot(tosite)

          const onkoMaksettavaa = maksutiedot.amount > 0
          const onkoMaksettavassaTilassa = paymentEnabledStatuses.includes(tosite.paymentStatus)
          const onkoHyvaksyttyJosHyvaksyntakiertoPaalla = !asiakas.paymentsNeedsApproval || tosite.maksuHyvaksytty
          const onkoMaksussaViiteTaiViesti = !!(maksutiedot.reference || maksutiedot.message)

          tosite.naytaValinta = onkoMaksettavaa && onkoMaksettavassaTilassa
          tosite.voidaanValita = tosite.naytaValinta && onkoHyvaksyttyJosHyvaksyntakiertoPaalla && onkoMaksussaViiteTaiViesti
          tosite.valittu = this._selectedMaksut.has(tosite.avain)

          const valintaOhjeistukset = []
          if (!tosite.voidaanValita) {
            if (!onkoMaksussaViiteTaiViesti) {
              valintaOhjeistukset.push(this._lemonTranslationService.lokalisoi('maksut.muokkaa.validation.viite.viite-tai-viesti'))
            }
            if (!onkoHyvaksyttyJosHyvaksyntakiertoPaalla) {
              valintaOhjeistukset.push(this._lemonTranslationService.lokalisoi('maksut.katsele.odottaa-hyvaksyntaa'))
            }
            if (valintaOhjeistukset.length) {
              tosite.valintaOhjeistus = valintaOhjeistukset.join('. ') + '.'
            }
          }

          const toimittaja = toimittajatMap.get(tosite.toimittajaAvain)
          if (toimittaja) {
            tosite.toimittaja = toimittaja
          }

          return tosite
        })
      }),
    )

    this.yhteensaRivitObservable = this.nakyvatRivitObservable.pipe(
      map(tositteet => {
        const valuuttaMap: { [valuuttaKey: string]: YhteensaRivi } = {}
        for (const tosite of tositteet) {
          const curr = tosite.currency ?? 'EUR'
          let valuutanYhteensaRivi = valuuttaMap[curr]
          if (!valuutanYhteensaRivi) {
            valuutanYhteensaRivi = {
              yhteensa: 0,
              valuutta: curr,
            }
            valuuttaMap[curr] = valuutanYhteensaRivi
          }
          valuutanYhteensaRivi.yhteensa += tosite.sum
        }
        return Object.keys(valuuttaMap)
          .map(a => valuuttaMap[a])
          .sort((a, b) => {
            return a.yhteensa - b.yhteensa
          })
      }),
      lemonShare(),
    )
    this.nakyvatRivitObservable
      .pipe(
        map(tositteet => {
          let sum = 0
          for (const tosite of tositteet) {
            if (tosite.paymentStatus === PaymentStatus.ERAANTYNYT) {
              sum += tosite.sum
            }
          }
          return sum
        }),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe(amount => this.eraantynytTo.set(amount))
    this.nakyvatRivitObservable
      .pipe(
        map(tositteet => {
          let sum = 0
          for (const tosite of tositteet) {
            if (tosite.paymentStatus === PaymentStatus.AVOIN || tosite.paymentStatus === PaymentStatus.MAKSUSSA) {
              sum += tosite.sum
            }
          }
          return sum
        }),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe(amount => this.avoinnaTo.set(amount))

    arvonMuutokset(this.kaikkiHakuLomake.toimittaja, { injector: this._injector })
      .pipe(takeUntil(this._ngUnsubscribe))
      .subscribe((value: string | TypeaheadToimittaja) => {
        if (this._stringService.isString(value)) {
          const kasitelty = this._formValidationService.processValue(value)
          this._toimittajaTypeahead
            .haeJaSuodata(kasitelty, true)
            .then(result => {
              this.suodatetutToimittajat.next(result.suodatetut)
            })
            .catch(err => {
              this._errorHandler.handleError(err)
            })
        }
      })

    arvonMuutokset(this.kaikkiHakuLomake, { injector: this._injector })
      .pipe(
        takeUntil(this._ngUnsubscribe),
        filter(value => typeof value.toimittaja === 'object' || !value.toimittaja), // Lasketaan läpi vain valittu toimittaja-objekti ja tyhjä arvo, jotta autocompleten täyttö ei käynnistä latausta
      )
      .subscribe(_ => {
        this.asetaKaikkiHakuParametrit()
      })
  }

  compareConfigs(o1: NaytettavaConfig, o2: NaytettavaConfig): boolean {
    if (o1 && o2) {
      // console.log(o1, o2)
      return o1.avain === o2.avain
    }
    return false
  }

  maksuAllSelectionChanged(tositteet: MaksutTosite[], event: MatCheckboxChange) {
    this._selectedMaksut.clear()
    for (const tosite of tositteet) {
      tosite.valittu = false
    }
    if (event.checked) {
      for (const tosite of tositteet) {
        if (tosite.voidaanValita) {
          tosite.valittu = true
          this._selectedMaksut.set(tosite.avain, tosite)
        }
      }
    }
    this._valitutTositteetSubject.next(Array.from(this._selectedMaksut.values()))
  }

  maksuSelectionChanged(valittuTosite: MaksutTosite, tositteet: MaksutTosite[], event: MatCheckboxChange) {
    if (event.checked) {
      if (valittuTosite.voidaanValita) {
        valittuTosite.valittu = true
        this._selectedMaksut.set(valittuTosite.avain, valittuTosite)
      }
    } else {
      valittuTosite.valittu = false
      this._selectedMaksut.delete(valittuTosite.avain)
    }
    this._valitutTositteetSubject.next(Array.from(this._selectedMaksut.values()))

    // Toggle select all accordingly
    let kaikkiValittu = true
    for (const tosite of tositteet) {
      if (tosite.voidaanValita && !this._selectedMaksut.has(tosite.avain)) {
        kaikkiValittu = false
        break
      }
    }

    if (this.selectAllCheckbox && this.selectAllCheckbox.checked !== kaikkiValittu) {
      this.selectAllCheckbox.checked = kaikkiValittu
    }
  }

  // private _setKk(hakukriteerit: Hakukriteerit) {
  //   const vuosiKk2 = hakukriteerit.vuosikk
  //   if (
  //     vuosiKk2 &&
  //     vuosiKk2.kk !== null &&
  //     vuosiKk2.kk !== undefined &&
  //     vuosiKk2.vuosi !== null &&
  //     vuosiKk2.vuosi !== undefined
  //   ) {
  //     const date2 = new Date(vuosiKk2.vuosi, vuosiKk2.kk, 1)
  //     if (!this.form.get('vuosikk').value) {
  //       this.form.get('vuosikk').setValue(date2, { emitModelToViewChange: true, emitViewToModelChange: false })
  //     } else {
  //       const existingDate = this.form.get('vuosikk').value as Date
  //       if (existingDate.getFullYear() !== date2.getFullYear() || existingDate.getMonth() !== date2.getMonth()) {
  //         this.form.get('vuosikk').setValue(date2, { emitModelToViewChange: true, emitViewToModelChange: false })
  //       }
  //     }
  //   } else {
  //     if (this.form.get('vuosikk').value !== null) {
  //       this.form.get('vuosikk').setValue(null, { emitModelToViewChange: true, emitViewToModelChange: false })
  //     }
  //   }
  // }

  get dataSource(): MaksutFirestoreDataSource {
    return this._dataSource
  }

  // chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
  //   this.form.get('vuosikk').setValue(normalizedMonth)
  //   datepicker.close()
  // }

  ngAfterViewInit() {
    this.sortQl.changes
      .pipe(
        switchMap((ql: QueryList<MatSort>) => {
          if (ql.first) {
            const currentSort = this.dataSource.sort
            ql.first.sort({
              id: currentSort.active,
              disableClear: true,
              start: currentSort.direction === 'asc' ? 'asc' : 'desc',
            })
            return ql.first.sortChange
          }
          return of<OstolaskuSort>(null)
        }),
        takeUntil(this._ngUnsubscribe),
      )
      .subscribe({
        next: (sort: OstolaskuSort) => {
          this.dataSource.sort = sort
        },
        error: err => {
          this._errorHandler.handleError(err)
        },
      })
    // this.windowSizeService.sizeObservable.pipe(
    //   takeUntil(this._ngUnsubscribe)
    // ).subscribe(koko => {
    //   setTimeout(() => {
    //     this.asetaListauksenKolumnit()
    //   }, 250)
    // })
  }

  private asetaListauksenKolumnit() {
    // this.naytaNro = true
    // this.naytaPvm = true
    // this.naytaSumma = true
    // const leveys = this.laskutaulu.nativeElement.offsetWidth
    // // if (tablenKoko < 500) {
    // //   this.propertiesToDisplay = [               'asiakas',         'erapvm',         'avoinna', 'merkitse']
    // // } else
    // if (leveys < 600) {
    //   this.propertiesToDisplay = ['tila', 'nro', 'asiakas', 'erapvm', 'avoinna', 'merkitse']
    //   // this.naytaNro = false
    //   this.naytaPvm = false
    //   this.naytaSumma = false
    // } else if (leveys < 700) {
    //   this.propertiesToDisplay = ['tila', 'nro', 'asiakas', 'erapvm', 'summa', 'avoinna', 'merkitse']
    //   // this.naytaNro = false
    //   this.naytaPvm = false
    // } else if (leveys < 800) {
    //   this.propertiesToDisplay = ['tila', 'nro', 'asiakas', 'pvm', 'erapvm', 'summa', 'avoinna', 'merkitse']
    //   // this.naytaNro = false
    // } else {
    //   this.propertiesToDisplay = ['tila', 'nro', 'asiakas', 'pvm', 'erapvm', 'summa', 'avoinna', 'merkitse']
    // }
  }

  ngOnDestroy() {
    this._ngUnsubscribe.next()
    this._ngUnsubscribe.complete()
  }

  onCountToEnd() {
    // this.laskuSummatService.numerotRullattiin()
  }

  avaaHaku() {
    this.hakuAvoinna = true
  }

  suljeHaku() {
    this.hakuAvoinna = false
  }

  async katsele(rivi: FirestoreTosite) {
    // if (this.selectedTabObservable.value === 'avoimet') {
    await this.dataSource.lockResultSet()
    // }

    const existing: MaksuKatseleComponentExistingData = {
      tosite: rivi,
    }
    this._katseleComponentDataResolve.asetaOlemassaolevaData(existing)
    this._router.navigate(['/maksut/', rivi.avain])
  }

  kuvavirheAvain: string = null
  kuvavirheParametrit: any = null
  private poistaFunktio: any = null
  private async tiedostoVoidaanLadata(tiedostot: FileDropEntry[]): Promise<boolean> {
    this.kuvavirheAvain = ''
    this.kuvavirheParametrit = {}
    // if (kuvienMaara > 1) {
    //   this.kuvavirheAvain = 'laskuasetukset.logo.virheet.vain-yksi-kerrallaan'
    //   setTimeout(() => {
    //     this.kuvavirheAvain = ''
    //   }, 10000)
    //   return false
    // }

    if (tiedostot.length < 1) {
      if (this.poistaFunktio) {
        clearTimeout(this.poistaFunktio)
      }
      this.kuvavirheAvain = 'kuitit.lataaminen.virheet.ei-tiedosto'
      this.poistaFunktio = setTimeout(() => {
        this.kuvavirheAvain = ''
      }, 15000)
      return false
    }

    const supportedImageTypes = ['jpeg', 'jpg', 'png', 'webp', 'tiff', 'gif', 'svg', 'pdf', 'heic', 'heif']
    for (const tiedosto of tiedostot) {
      const file = tiedosto.fileEntry as FileSystemFileEntry

      const fileEnding = this._tiedostojenLataamisService.getFileEndingFromFileName(file.name)
      const fileSize = file ? await this._tiedostojenLataamisService.getFileSize(file) : -1

      // console.log(fileSize, file)

      if (!fileEnding || supportedImageTypes.indexOf(fileEnding.toLowerCase()) < 0) {
        if (this.poistaFunktio) {
          clearTimeout(this.poistaFunktio)
        }
        this.kuvavirheParametrit = {
          tuetutMuodot: supportedImageTypes.join(', '),
        }
        this.kuvavirheAvain = 'kuitit.lataaminen.virheet.vaara-muoto'
        this.poistaFunktio = setTimeout(() => {
          this.kuvavirheAvain = ''
        }, 15000)
        return false
      }

      const maxKoko = 25 * 1024 * 1024
      if (fileSize > maxKoko) {
        if (this.poistaFunktio) {
          clearTimeout(this.poistaFunktio)
        }
        const kokoMegatavuissaLokalisoitu = this._currencyService.formatoiDesimaali(fileSize / 1024 / 1024, 2, this._lemonTranslationService.nykyinenKieli)
        const maxKokoLokalisoitu = this._currencyService.formatoiDesimaali(maxKoko / 1024 / 1024, 2, this._lemonTranslationService.nykyinenKieli)
        this.kuvavirheParametrit = {
          kokoMax: maxKokoLokalisoitu,
          kokoNyt: kokoMegatavuissaLokalisoitu,
        }
        this.kuvavirheAvain = 'kuitit.lataaminen.virheet.liian-suuri'
        this.poistaFunktio = setTimeout(() => {
          this.kuvavirheAvain = ''
        }, 15000)
        return false
      }
    }

    return true
  }

  naytaTiedostonValintaDialogi() {
    this.fileInput.nativeElement.click()
  }

  async fileChanged(event) {
    const list: FileList = event.target.files
    const tiedostot: FileDropEntry[] = this._tiedostojenLataamisService.fileListToNgxFileDropEntries(list)

    const voidaanLadata = await this.tiedostoVoidaanLadata(tiedostot)
    if (!voidaanLadata) {
      return
    }
    this.siirryLuomiseen(tiedostot)
  }

  private siirryLuomiseen(tiedostot: FileDropEntry[]) {
    const data: MaksuLuoUusiComponentData = {
      tiedostot: tiedostot,
    }
    this._luoComponentDataResolve.asetaOlemassaolevaData(data)
    this._router.navigate(['/maksut/uusi'])
  }

  // lisaa() {

  // this.laskuService.asetuksetObservable.pipe(
  //   take(1)
  // ).subscribe(asetukset => {
  //   if (asetukset) {
  //     if (this.asetustenOletuksetService.tarkistaPuuttuukoLaskuasetuksia(asetukset)) {
  //       this.naytaTaydennaAsetuksetDialogi()
  //     } else {
  //       // Sulje dialogi, jos sellainen oli
  //       if (this._taydennaAsetuksetDialogi) {
  //         this._taydennaAsetuksetDialogi.close()
  //         this._taydennaAsetuksetDialogi = null
  //       }
  //       this.router.navigate(['/laskutus/laskut/', 'uusi', 'uusi'])
  //     }
  //   }
  // })

  // }

  // private naytaTaydennaAsetuksetDialogi() {
  //   if (!this._taydennaAsetuksetDialogi) {
  //     const kaytettavaLeveys = window.innerWidth
  //     const kaytettavaKorkeus = window.innerHeight
  //     const leveys = kaytettavaLeveys > 900 ? '90vw' : '98vw'
  //     const korkeus = kaytettavaKorkeus > 1100 ? '80vh' : kaytettavaKorkeus > 750 ? '85vh' : '92vh'

  //     const settings: MatDialogConfig = {
  //       maxWidth: '900px',
  //       maxHeight: korkeus,
  //       width: leveys,
  //       data: {
  //         mobiili: kaytettavaLeveys < 670
  //       }
  //     }

  //     this._taydennaAsetuksetDialogi = this.dialog.open(LaskuTaydennaAsetuksetDialog, settings)
  //     this._taydennaAsetuksetDialogi.afterClosed().subscribe(result => {
  //       this._taydennaAsetuksetDialogi = null
  //       if (result === 'onnistui') {
  //         this.router.navigate(['/laskutus/laskut/', 'uusi', 'uusi'])
  //       }
  //     })
  //   }
  // }

  /**
   * Maksut tallennetaan ensi FirestoreTositteiksi.
   * Käyttäjä valitsee haluamansa maksut ja aloittaa vahvan tunnistautumisen.
   * Aloittamisen yhteydessä kaikki valitut maksut kirjoitetaan tietokantaan.
   * (Vain näiden avaimet)
   *
   * Kun vahva tunnistautuminen on onnistunut, kirjoitetaan nämä maksut työjonoon,
   * joka tekee varsinaiset maksut payments-projektiin.
   */
  async maksaHeti() {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    if (!this._valittuNaytettavaConfigSubject.value?.debtorIdentifier) {
      // TODO! Indicate to user that a payment config has to be selected
      return
    }
    const data: MaksutVahvistusData = {
      maksut: Array.from(this._selectedMaksut.keys()),
      dueType: 'heti',
      paymentConfigId: this._valittuNaytettavaConfigSubject.value?.avain,
    }
    this._router.navigate(['maksut/vahvista'], { state: data, skipLocationChange: true })
  }

  async maksaErapaivana() {
    if (await this._kayttajaService.kayttajaaImpersonoidaan()) {
      return
    }

    if (!this._valittuNaytettavaConfigSubject.value?.debtorIdentifier) {
      // TODO! Indicate to user that a payment config has to be selected
      return
    }
    const data: MaksutVahvistusData = {
      maksut: Array.from(this._selectedMaksut.keys()),
      dueType: 'erapaivana',
      paymentConfigId: this._valittuNaytettavaConfigSubject.value?.avain,
    }
    this._router.navigate(['maksut/vahvista'], { state: data, skipLocationChange: true })
  }

  navigateToSettings() {
    this._router.navigate(['/maksut/asetukset/vastaanotto'])
  }

  naytettavaTunniste(ytunnus: string | null) {
    return this._toimittajaTunnisteService.naytettavaTunnisteArvosta(ytunnus)
  }

  toimittajaDisplayFn(toimittaja: LaskuToimittaja): string {
    if (toimittaja && toimittaja.nimi) {
      return toimittaja.nimi
    }
    return ''
  }
}
